export const DEFAULT_ZOOM_LEVEL = 14;
export const HIGHEST_ALLOWED_ZOOM_LEVEL = 19; // This is the most zoomed in
export const LOWEST_ALLOWED_ZOOM_LEVEL = 4; // This is the most zoomed out
export const INFO_WINDOW_DOM_ID = 'sh-google-map-infowindow';
export const mapTypeToCssClass = {
    disabled: 'disabled',
    medium: 'default',
    recent: 'viewed',
};
export const MAP_OPTIONS = {
    maxZoom: HIGHEST_ALLOWED_ZOOM_LEVEL,
    minZoom: LOWEST_ALLOWED_ZOOM_LEVEL,
    clickableIcons: false,
    disableDefaultUI: true,
    /* Google Maps documentation is somewhat lacking in explanation of default gestureHandling behavior.
      The blog linked below describes the gestureHandling "auto" value in a little more detail:
      it can change gestureHandling to cooperative or greedy depending on whether the map
      is in an iframe of the page is considered scrollable.
      https://developers.google.com/maps/documentation/javascript/interaction#gesturehandling_greedy
      https://cloud.google.com/blog/products/maps-platform/smart-scrolling-comes-to-mobile-web-maps
  */
    gestureHandling: 'auto',
};
